
import router from "@/app/ui/router";
import { computed, defineComponent, onMounted, ref } from "vue";
import i18n from "@/i18n";
import TabRiwayatFollowUp from "./tab-riwayat-follow-up.vue";
import TabRiwayatHanging from "./tab-riwayat-hanging.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";

export default defineComponent({
  name: "PageHistoryHangingBKD",

  setup() {
    const t = i18n.global.t;
    const tabs = [
      {
        title: String(t("dashboard.hanging.historyHangingTab")),
        value: "history-hanging-bkd",
        component: TabRiwayatHanging
      },
      {
        title: String(t("dashboard.hanging.historyFollowUpTab")),
        value: "history-follow-up-bkd",
        component: TabRiwayatFollowUp
      }
    ];

    const activeMenu = ref(tabs[0].value);

    const onChangeTabs = (value: string) => {
      activeMenu.value = value;
      router.push({ name: value });
    };

    const activeTabComponent = computed(() => {
      const current = tabs.find((tab) => tab.value === activeMenu.value);
      return current?.component || null;
    });

    onMounted(() => {
      const currentName = router.currentRoute.value.name as string;
      if (tabs.some((tab) => tab.value === currentName)) {
        activeMenu.value = currentName;
      }
    });

    return {
      activeMenu,
      activeTabComponent,
      tabs,
      onChangeTabs,
      isSidebarAndBreadcrumbV2: computed(
        () => MainAppController.isSidebarAndBreadcrumbV2
      )
    };
  }
});
